module.exports = __webpack_public_path__ + "img/call.1fe629aa.png";